import {
  AfterContentInit,
  Component,
  ContentChildren,
  Input,
  OnInit,
  QueryList,
} from '@angular/core';
import { TreoAnimations } from '@treo/animations';
import { TableCardRowComponent } from './table-card-row/table-card-row.component';

@Component({
  selector: 'ew-table-card',
  templateUrl: './table-card.component.html',
  styleUrls: ['./table-card.component.scss'],
  animations: TreoAnimations,
})
export class TableCardComponent implements OnInit, AfterContentInit {
  // @Input() progress: { total: number, current: number } = null;
  @ContentChildren(TableCardRowComponent)
  rowComponents!: QueryList<TableCardRowComponent>;

  rows: Array<TableCardRowComponent> = [];

  constructor() {}

  ngOnInit(): void {}

  ngAfterContentInit(): void {
    setTimeout(() => {
      this.rows = this.rowComponents.toArray();
    }, 0);
  }
}
